<template>
  <div class="page-view">
    <div class="scroll-view-wrapper article-view">
      <div class="article-header">
        <Header
          :isXue="isXue"
          v-if="isApp"
          @backFn="backFn"
          :pageTitle="newsInfo.title"
          @share="shareAction"
        ></Header>
      </div>
      <div class="news-detail-title">
        <h3>{{ newsInfo.title }}</h3>
      </div>
      <div class="createTime p-lr32 font-28">{{ newsInfo.createdDate }}</div>
      <div
        class="news-detail-container"
        ref="newsInfoRef"
        v-html="
          newsInfo.content &&
          newsInfo.content.replace(
            /\ssrc/g,
            ' referrerpolicy=no-referrer ' + 'src'
          )
        "
      ></div>
      <div class="ui-safe-area-inset"></div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  nextTick,
  onMounted,
  getCurrentInstance
} from 'vue'
import { exerReq } from '@/api'
import { ImagePreview, Toast } from 'vant'
import Header from '@/components/common/Header.vue'
import { useRoute } from 'vue-router'
import {
  validateXue,
  jumpModuleApp,
  appShare,
  appPort,
  hiddenAppNavBar,
  closeAppView
} from '@/widget/index'

export default defineComponent({
  setup() {
    const {
      proxy: { $showLoading, $hideLoading }
    } = getCurrentInstance()
    const route = useRoute()
    const id = ref(route.params.id)
    const isApp = ref(appPort())
    if (isApp.value) {
      hiddenAppNavBar()
    }
    const newsInfo = ref(Object.create(null))
    let images = []
    const picIndex = ref(0)
    const newsInfoRef = ref(null)
    const shareData = ref(Object.create(null))

    const getNewsDetail = () => {
      $showLoading()
      exerReq
        .getArticleDetail({
          articleId: id.value
        })
        .then(result => {
          $hideLoading()
          const data = result.data
          if (Number(result.code) === 200) {
            const {
              detail: { content, shareCover, shareDescription, shareName },
              name: title,
              createdDate
            } = data
            newsInfo.value = { content, title, createdDate }
            shareData.value = {
              title: shareName,
              desc: shareDescription,
              image: shareCover,
              url: window.location.href
            }
            document.title = title
            nextTick(() => {
              getImgList()
            })
          } else {
            Toast(result.message)
          }
        })
    }
    const getImgList = () => {
      const imgs = document.querySelectorAll('img')
      Array.from(imgs).forEach((item, index) => {
        images.push(item.src)
        item.addEventListener(
          'click',
          event => {
            const href = event.currentTarget.getAttribute('href')
            if (href && href.indexOf('/mall/detail') > -1) {
              if (isApp.value) {
                const id = href.replace(/h5|[^0-9]/g, '')
                jumpModuleApp({
                  typeId: 'mall_detail',
                  dataId: id
                })
                event.preventDefault()
                event.stopPropagation()
              }
            } else {
              if (isApp.value) {
                jumpModuleApp({
                  typeId: 'image_preview',
                  images: images,
                  posIndex: index
                })
              } else {
                ImagePreview({
                  images: images,
                  closeable: true,
                  startPosition: index
                })
              }
            }
          },
          false
        )
      })
    }
    const shareAction = () => {
      if (isApp.value) {
        appShare(shareData)
      }
    }

    onMounted(() => {
      getNewsDetail()
    })

    const isXue = ref(validateXue())
    const backFn = () => {
      // 返回
      if (isXue.value) {
        closeAppView()
      } else {
        history.go(-1)
      }
    }
    return {
      newsInfoRef,
      picIndex,
      newsInfo,
      shareAction,
      isApp,
      isXue,
      backFn
    }
  },
  components: {
    Header
  }
})
</script>
<style lang="scss" scoped>
@import '~@/components/exercise/style/default.scss';
.article-view {
  background-color: #fff;
}
.article-header {
  border-bottom: 2px solid #f5f5f7;
}
.news-detail-title {
  padding: 0 32px;
  margin-top: 32px;
  margin-bottom: 32px;
  h3 {
    font-size: 40px;
    color: #232323;
    font-weight: bold;
    line-height: 56px;
  }
}
.createTime {
  line-height: 40px;
  color: #afafb3;
  padding-bottom: 24px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    border-bottom: 1px solid #e4e5eb;
    bottom: 0;
    left: 32px;
    right: 32px;
  }
}
.news-detail-container {
  padding: 32px 32px 0;
  font-size: 28px;
  img {
    max-width: 100%;
  }
  p,
  span {
    line-height: 24px;
  }
}
</style>
